import React from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";
import { DATE_FORMAT_FOR_DISPLAY } from "../../constants/constants";

/**
 *
 * @param {boolean} accountedFor: arriva dal tab contabilizzati TRUE altrimenti FALSE
 * @returns
 */
export const columnsInvoices = (
  accountedFor, jsonCurrency, navigate
) => {
  return [
    {
      title: "Data documento",
      dataIndex: "doc",
      key: "doc",
      render: (doc) => <>{moment(doc?.date).format("DD/MM/YYYY")}</>
    },
    {
      title: "Caricamento",
      dataIndex: "doc",
      key: "upload",
      render: (doc) => {
        return doc?.sdiCode ? (
          <div style={{ color: "#0090d1", paddingLeft: 5 }}>SDI</div>
        ) : (
          <div style={{ color: "#0090d1", paddingLeft: 5 }}>
            <FontAwesomeIcon icon={["far", "upload"]} />
          </div>
        );
      }
    },
    {
      title: "Ricezione",
      key: "receiving",
      render: (data) => <>{data?.doc?.active ? "-" : data?.doc?.sdiDate ? moment(data?.doc?.sdiDate).format("DD/MM/YYYY") : "-"}</>
    },
    {
      title: "Cliente / Fornitore",
      key: "supplier",
      render: (data) => (
        <>
          {data?.doc?.active
            ? data?.customerName
              ? `${data?.customerName} - ${data?.customerVATNumber ? data?.customerVATNumber : data?.customerTaxId}`
              : (data?.customerVATNumber ? data?.customerVATNumber : data?.customerTaxId)
            : data?.supplierName
              ? `${data?.supplierName} - ${data?.supplierVATNumber ? data?.supplierVATNumber : data?.supplierTaxId}`
              : (data?.supplierVATNumber ? data?.supplierVATNumber : data?.supplierTaxId) }
        </>
      )
    },
    {
      title: "Descrizione",
      key: "reasonId",
      render: (data) => {
        let description;
        if (typeof data?.doc?.active !== "undefined") {
          if (data?.doc?.active) {
            description = "Vendita";
          } else {
            description = "Acquisto";
          }
        }
        return (
          <>
            {description} - {data?.doc?.number}
          </>
        );
      }
    },
    {
      title: "Causale Contabile",
      dataIndex: "reason",
      key: "reason"
    },
    {
      title: "Importo",
      dataIndex: "amount",
      key: "amount",
      render: (amount, data) => {
        return (
          <div style={{ textAlign: "end", paddingRight: 40 }}>
            {numeral(Math.abs(amount)).format("0,0.00")} {jsonCurrency?.[data?.refCurrency || "EUR"]?.symbol || "€"}
          </div>
        );
      }
    },
    {
      title: "",
      key: "actions",
      render: (data) => {        
        return (
          <FontAwesomeIcon
            className="preCog-doc-list-edit-icon"
            icon={["far", "pen"]}            
            onClick={() => navigate({ pathname: "/precog-detail/" + data.id, state: { accountedFor: accountedFor }})}
          />
        );
      }
    }
  ];
};

export const columnsWithholding = (getWithholdingDetail) => {
  return [
    {
      title: "Fornitore",
      dataIndex: "supplier",
      key: "supplier"
    },
    {
      title: "N° documento",
      dataIndex: "documentNumber",
      key: "documentNumber"
    },
    {
      title: "Data documento",
      dataIndex: "documentDate",
      key: "documentDate",
      render: (value, obj) => {
        return <span>{moment(value).format(DATE_FORMAT_FOR_DISPLAY)}</span>;
      }
    },
    {
      title: "Importo documento",
      dataIndex: "documentAmount",
      key: "documentAmount",
      render: (value, obj) => { 
        /** todo chiedere la valuta lato BE */
        return <span>{value} €</span>;
      }
    },
    {
      title: "Importo ritenuta dovuta",
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (value, obj) => { 
        /** todo chiedere la valuta lato BE */
        return <span>{value} €</span>;
      }
    },
    {
      title: "Importo ritenuta inviata F24",
      dataIndex: "sentAmount",
      key: "sentAmount",
      render: (value, obj) => { 
        /** todo chiedere la valuta lato BE */
        return <span>{value} €</span>;
      }
    },
    {
      title: "Importo residuo da versare",
      dataIndex: "residualAmount",
      key: "residualAmount",
      render: (value, obj) => { 
        /** todo chiedere la valuta lato BE */
        return <span>{value} €</span>;
      }
    },
    {
      title: "",
      key: "vOpenDrawer",
      render: (/* row*/) => {
        /* <div
            className="precog-list-withholdings-detail-column"
            onClick={() => {
              getWithholdingDetail(row.uuid);
            }}
          >
            <FontAwesomeIcon icon={["far", "external-link-square-alt"]} />
          </div>*/
        return (
          <div></div>
        );
      }
    }
  ];
};
